// Sticky footer that appears at the very bottom of the emergency app
// once a partner branding is active. Keeps SafetyAssist's origin visible
// as tiny attribution without competing with the partner brand at the top.
import React from "react";
import { useI18n } from "../lib/i18n";
import { useQr } from "../lib/qrContext";

export const PoweredByFooter = () => {
    const { t } = useI18n();
    const { brandingLogoUrl } = useQr();
    if (!brandingLogoUrl) return null;
    return (
        <div
            data-testid="powered-by-footer"
            className="mt-auto pt-6 pb-4 text-center"
        >
            <div className="text-xs sm:text-sm font-display font-bold text-zinc-700">
                {t("powered_by_line1")}
            </div>
            <div className="text-[11px] sm:text-xs text-zinc-500 mt-0.5">
                {t("powered_by_line2")}
            </div>
        </div>
    );
};
